import Vue from 'vue';
let $http = Vue.prototype.$http;

// 登录
// export const Login = (params) => $http({
//     url:'index/login',
//     method:'post',
//     params
// }).then(res=>{
//     return res.data;
// })

// 修改密码
export const postApiChangePassword = (params) => $http.post('api/v1/common/up_pwd', params).then(res => {
    return res.data
})

// 集中培训项目
export const FocusProjectList = (params) => $http.get('api/v1/front_student/my_project', { params }).then(res => {
    return res.data
})

// 班级基本情况
export const ClassCondition = (params) => $http.get('api/v1/front_student/my_student_home_show', { params }).then(res => {
    return res.data
})

// 获取班级列表
export const GetClassList = (params) => $http.get('api/v1/mini_home/student_select_class_list', { params }).then(res => {
    return res.data
})

// 获取当前成绩
export const GetCurrentScore = (params) => $http.get('api/v1/mini_home/student_ranking_details', { params }).then(res => {
    return res.data
})

// 学情统计
export const studyTotal = (params) => $http.get('api/v1/front_student/home_group', { params }).then(res => {
    return res.data
})

// 日程安排
export const DayArrange = (params) => $http.get('api/v1/front_student/student_tree_list', { params }).then(res => {
    return res.data
})

// 节点详情
export const NodeDetails = (params) => $http.get('api/v1/mini_home/student_schedule_list', { params }).then(res => {
    return res.data
})

// 作业列表
export const TrainWorkList = (params) => $http.get('api/v1/front_student/student_work_list', { params }).then(res => {
    return res.data
})

//作业详情
export const WorkDetail = (params) => $http.get('api/v1/work/student_wx_work_detail', { params }).then(res => {
    return res.data
})

// 提交作业
export const CommitWork = (params) => $http.post('api/v1/work/student_wx_work_submit', params).then(res => {
    return res.data
})

// 作业修改
export const UpdateWorkApi = (params) => $http.post('api/v1/work/student_wx_work_edit', params).then(res => {
    return res.data
})

// 文件预览
export const previewOffice = (params) => $http({
    url: 'api/v1/public_common/preview_office',
    method: 'get',
    params,
}).then(res => {
    return res.data
})

// 金山云配置
export const GetKey_Url = (params) => $http.get('api/v1/common/get_kingsoft', { params }).then(res => {
    return res.data
})

//金山云上传
export const UPloadFileApi = (params) => $http.get('api/v1/public_common/get_success_file', { params }).then(res => {
    return res.data
})

//问卷列表
export const QuestionListApi = (params) => $http.get('api/v1/front_student/student_questionnaire_list', { params }).then(res => {
    return res.data
})

//问卷详细
export const QuestionDetailApi = (params) => $http.get('api/v1/questionnaire/student_wx_questionnaire_detail', { params }).then(res => {
    return res.data
})

//提交问卷
export const commitQuestion = (params) => $http({
    url: `api/v1/questionnaire/student_wx_questionnaire_submit`,
    method: 'post',
    data: params
}).then(res => {
    return res.data;
})

//资源列表
export const ResourseListApi = (params) => $http.get('api/v1/front_student/student_wx_resources_list', { params }).then(res => {
    return res.data
})

//面授课列表
export const FaceCourseApi = (params) => $http.get('api/v1/f_fteaching/student_ffteaching_list', { params }).then(res => {
    return res.data
})

//班级简介
export const ClassDescApi = (params) => $http.get('api/v1/mini_home/class_student_show', { params }).then(res => {
    return res.data
})

//通知公告
export const ClassNoticeApi = (params) => $http.get('api/v1/front_student/my_notice_list', { params }).then(res => {
    return res.data
})

//通知公告详情
export const ClassNoticeDetailApi = (params) => $http.get('api/v1/myself/notice_detail', { params }).then(res => {
    return res.data
})

// 考核规则
export const CheckRulesApi = (params) => $http.get('api/v1/reception_task/student_wx_tree_list', { params }).then(res => {
    return res.data
})

// 学情统计
export const StudyStatistics = (params) => $http.get('api/v1/front_student/space_learning', { params }).then(res => {
    return res.data
})

// 学习行为
export const StudyBehaivor = (params) => $http.get('api/v1/front_student/space_behavior', { params }).then(res => {
    return res.data
})

// 学习档案的培训项目
export const StudyProjectApi = () => $http.get('api/v1/front_student/my_project_simple').then(res => {
    return res.data
})

// 获取短信验证码
export const GetNoteCode = (params) => $http.post('api/v1/wechat_auth/send_pass_code', params).then(res => {
    return res.data
})

// 节点列表数量
export const PointerNumber = (params) => $http.get('api/v1/front_student/get_to_type_count', { params }).then(res => {
    return res.data
})

// 进入的班级
export const enterClass = (params) => $http.post('api/v1/mini_home/enter_class', params).then(res => {
    return res.data
})

// 学员列表
export const StudentList = (params) => $http.get('api/v1/front_student/get_class_student_list', { params }).then(res => {
    return res.data
})

// 小组列表
export const GroupList = (params) => $http.get('api/v1/front_student/get_class_group_list', { params }).then(res => {
    return res.data
})

// 忘记密码
export const UpdatePasswork = (params) => $http.post('api/v1/login/forget_password', params).then(res => {
    return res.data
})

// 文件预览/下载次数
export const FileBrowserCount = (params) => $http.post('api/v1/resources/check_schedule_resources', params).then(res => {
    return res.data
})

// 生成二维码
export const getCode = (params) => $http.post('api/v1/login/create_token_qrcode', params).then(res => {
    return res.data
})

// 轮询扫描状态
export const WatchCodeStatus = (params) => $http({
    url: 'api/v1/login/polling_token_qrcode',
    method: 'post',
    params,
    headers: {
        "unShowLoading": true
    }
}).then(res => {
    return res.data;
})

// 住宿
export const getApiDormitory = (params) => $http.get('api/v1/student/Hotel', { params }).then(res => {
    return res.data
})

// 住宿报名
export const postApiDormitorySign = (params) => $http.post('api/v1/student/Hotel/canApply', params).then(res => {
    return res.data
})

// 住宿介绍
export const getApiDormitoryIntroduce = (id,params) => $http.get(`api/v1/student/Hotel/detail/${id}`, { params }).then(res => {
    return res.data
})

// 报餐
export const getApiMeal = (params) => $http.get('api/v1/student/Feed', { params }).then(res => {
    return res.data
})

// 报餐报名
export const postApiMealSign = (params) => $http.post('api/v1/student/Feed/canApply', params).then(res => {
    return res.data
})

// 培训手册详情
export const getApiTrainingHandbookDetails  = (params) => $http.get('api/v1/student/manual/detail',{params}).then(res => {
    return res.data
})